module.exports = __webpack_public_path__ + "img/img_7.a5269970.png";